import React, { useEffect, useState } from 'react'
import './styles.scss';
import { selectMainState, useSelector } from "src/stateManagement/redux";
import Grid from "@mui/material/Grid2";
import { Badge, Box, Button, CircularProgress, FormControl, IconButton, InputLabel, Link, MenuItem, Select, Tooltip, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { ProjectsCardProps, uploadViews } from 'src/tecnica/pages/upload/page';
import { ProjectList } from 'src/stateManagement/redux/slices/shared/interfaces';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AddIcon from '@mui/icons-material/Add';
import { StatesTabs } from '../consolidate_files/upload-modal/statesTabs';
import { getExcelFileToJson, getSheetNamesFromExcel } from 'src/shared/util/functions';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { addWellInformation } from 'src/shared/util/updateDataServer';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import DashboardIcon from "@mui/icons-material/Dashboard";

import Swal from 'sweetalert2';
import { downloadExcelFormat } from 'src/shared/util/downloadExcel';

export interface IWellFileComponenetProps {
    id: string;
}

interface IchangeResponse {
    id: any;
    location: string;
    message: string;
}

interface ItestFileRespondes {
    changes: IchangeResponse[];
    errors: IchangeResponse[];
    commitChange: boolean;
    executed: boolean;
}

interface IDownloadFormat {
    id: string;
    typeOrFormat: string;
}

const internalTabs = [
    { "name": "Resumen", "value": "summary", icon: <TextSnippetIcon /> },
    { "name": "Detalles", "value": "details", icon: <DashboardIcon /> },
]

const downladFormatsEnableFor = [
    { id: "wellTags", typeOrFormat: "locationTags" },
]

export const WellFileComponenet = ({ id }: IWellFileComponenetProps) => {

    const { configModules } = useSelector(selectMainState);

    const [activeCard, setActiveCard] = useState<ProjectsCardProps>()

    const [projectList, setprojectList] = useState<ProjectList[]>([])

    const [projectId, setProjectId] = useState("");

    const [sheet, setSheet] = React.useState('');

    const [file, setFile] = React.useState<File | null>(null);

    const [excelSheets, setexcelSheets] = useState<string[]>([])

    const [showDownloadFormat, setShowDownloadFormat] = useState<IDownloadFormat>()

    // const [enableUpload, setEnableUpload] = useState(false)

    const [filterStates, setFilterStates] = useState([
        { id: "changes", name: "Cambios a General", amountElement: 0 },
        { id: "errors", name: "Errores", amountElement: 0 },
    ])

    const [testFielResponse, setTestFielResponse] = useState<ItestFileRespondes>()

    const [rawFielResponse, setRawFielResponse] = useState<ItestFileRespondes>()

    const [activeState, setActiveState] = useState(filterStates[0].id)

    const [loading, setLoading] = useState(false)

    const [startRow, setStartRow] = useState<number>(1)

    const paginationModel = { page: 1, pageSize: 10 };

    const [activeSummaryView, setactiveSummaryView] = useState(internalTabs[0].value)


    useEffect(() => {
        const card = uploadViews.find(card => card.id === id);
        setActiveCard(card);

        const cardHaveDownloadFormat = downladFormatsEnableFor.find(format => format.id === card?.id);
        if (cardHaveDownloadFormat) {
            setShowDownloadFormat(cardHaveDownloadFormat);
        } 

    }, [id])

    useEffect(() => {
        if (configModules?.projectList) {
            setprojectList(configModules?.projectList);
        }

    }, [configModules])

    useEffect(() => {
        if (file) {
            setLoading(true);
            getSheetNamesFromExcel(file).then((sheets) => {
                setexcelSheets(sheets);
            }).finally(() => {
                setLoading(false);
            });
        }
    }, [file])

    useEffect(() => {
        if (activeSummaryView == "summary") {
            const uniqueChanges: IchangeResponse[] = []
            const uniqueErrors: IchangeResponse[] = []

            rawFielResponse?.changes.forEach(change => {

                const existingChange = uniqueChanges.findIndex(c => c.message === change.message);

                if (existingChange !== -1) {
                    let number: any = uniqueChanges[existingChange].location?.split(':')[1]?.trim();

                    try {
                        number = parseInt(number) + 1;
                        uniqueChanges[existingChange].location = `Se repite : ${number}`
                    } catch (error) {
                        console.log("Error al procesar el número de locación:", error);
                    }
                } else {
                    uniqueChanges.push({
                        id: uniqueChanges.length + 1,
                        location: `Se repite : 1`,
                        message: change.message
                    });
                }
            });

            rawFielResponse?.errors.forEach(error => {

                const existingError = uniqueErrors.findIndex(e => e.message === error.message);

                if (existingError !== -1) {
                    let number: any = uniqueErrors[existingError].location?.split(':')[1]?.trim();

                    try {
                        number = parseInt(number) + 1;
                        uniqueErrors[existingError].location = `Se repite : ${number}`
                    } catch (error) {

                    }
                } else {
                    uniqueErrors.push({
                        id: uniqueErrors.length + 1,
                        location: `Se repite : 1`,
                        message: error.message
                    });
                }
            });

            setTestFielResponse({
                changes: uniqueChanges,
                errors: uniqueErrors,
                commitChange: rawFielResponse?.commitChange || false,
                executed: rawFielResponse?.executed || false
            });


        } else {
            setTestFielResponse(rawFielResponse);
        }
    }, [activeSummaryView, rawFielResponse])


    const handleTestFile = async () => {
        if (!file || !sheet || !projectId || !startRow) {
            alert("Por favor, completa todos los campos antes de testear el archivo.");
            return;
        }

        setLoading(true);

        try {
            const excelJsonCotent = await getExcelFileToJson(file, sheet, startRow);

            const response = await addWellInformation({
                projectId,
                id,
                data: excelJsonCotent,
                commitChange: false
            })

            setFilterStates([
                { id: "changes", name: "Cambios a General", amountElement: response?.changes?.length || 0 },
                { id: "errors", name: "Errores", amountElement: response?.errors?.length || 0 },
            ])

            setRawFielResponse(response);

        } catch (error) {
            console.error("Error al procesar el archivo:", error);
            alert("Ocurrió un error al procesar el archivo. Por favor, inténtalo de nuevo.");
            return;
        } finally {
            setLoading(false);
        }

    }

    const navigate = useNavigate();

    const handleOnGoback = () => {
        navigate(-1);
    }

    const handleDelteFile = () => {
        setFile(null);
        setexcelSheets([]);
        setRawFielResponse(undefined);
        setTestFielResponse(undefined);
        setActiveState(filterStates[0].id);
    }

    const columnsForChanges: GridColDef[] = [
        { field: "id", headerName: "id", width: 10 },
        { field: "location", headerName: "Locación", flex: 0.25 },
        { field: "message", headerName: "Mensaje", flex: 1 }
    ];

    const onClickChangeSummaryView = (tabId: string) => {
        setactiveSummaryView(tabId)
    }

    const handleCommitChanges = async () => {
        if (!file || !sheet || !projectId || !startRow) {
            alert("Por favor, completa todos los campos antes de testear el archivo.");
            return;
        }

        setLoading(true);
        try {
            const excelJsonCotent = await getExcelFileToJson(file, sheet, startRow);

            const response = await addWellInformation({
                projectId,
                id,
                data: excelJsonCotent,
                commitChange: true
            })

            if (response?.commitChange) {
                let title = response?.executed ? "Cambios guardados correctamente" : "Cambios no ejecutados";
                Swal.fire({
                    title,
                    icon: response?.executed  ? "success" : "warning",
                    // showCancelButton: true,
                    confirmButtonText: "Cerrar",
                });
            }
        } catch (error) {
            console.error("Error al procesar el archivo:", error);
            alert("Ocurrió un error al procesar el archivo. Por favor, inténtalo de nuevo.");
            return;
        } finally {
            setLoading(false);
        }
    }

    const handleDownloadFormat = () => {
        if(showDownloadFormat){
            downloadExcelFormat(showDownloadFormat?.typeOrFormat)
        }
    }


    return (
        <>
            {loading && (
                <Grid className="loading_container">
                    <Grid className="info_container">
                        <CircularProgress size="5rem" />
                        <Typography>Cargando.......</Typography>
                    </Grid>
                </Grid>
            )}
            <Grid className="well_files_container">
                {/* header */}
                <Grid className="header_container_well_files">
                    <IconButton
                        color="primary"
                        size="large"
                        onClick={() => handleOnGoback()}
                    >
                        <ArrowBackIcon />
                    </IconButton>
                    <Grid className="text_section">
                        <Typography className="title">
                            {activeCard ? activeCard?.title : ""}
                        </Typography>
                    </Grid>
                </Grid>
                {/* Body */}
                <Box className="well_files_custom_container">
                    {/* 1. Seleccione el campo */}
                    <Grid container>
                        <Grid size={8}>
                            <Typography className="section_title">
                                1.- Seleccione el campo
                            </Typography>
                        </Grid>
                        <Grid size={4} sx={{
                            display:'flex'
                        }}>
                            <FormControl
                                size="small"
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    width: "50%",
                                }}
                            >
                                <InputLabel>Campo</InputLabel>
                                <Select
                                    value={projectId}
                                    label="Campo"
                                    onChange={(e) =>
                                        setProjectId(e.target.value)
                                    }
                                >
                                    {projectList.map((f, index) => (
                                        <MenuItem
                                            key={index}
                                            value={f.projectId}
                                        >
                                            {f.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                    {/* 2. Seleccione el Archivo */}
                    <Grid className="section_container">
                        <Grid>
                            <Typography className="section_title">
                                2.- Seleccione el Archivo
                            </Typography>
                            <Typography className="section_description">
                                Los archivos válidos son excel{" "}
                                {showDownloadFormat && (
                                    <Link
                                        onClick={() => handleDownloadFormat()}
                                        href="#"
                                    >
                                        {" "}
                                        descargar formato aqui
                                    </Link>
                                )}
                            </Typography>
                        </Grid>
                        <Grid className="left_section">
                            {file ? (
                                <Grid className="files_element">
                                    <Typography className="file_name">
                                        {file.name}
                                    </Typography>
                                    <IconButton
                                        color="error"
                                        size="large"
                                        onClick={() => handleDelteFile()}
                                    >
                                        <DeleteForeverIcon />
                                    </IconButton>
                                </Grid>
                            ) : (
                                <Box className="file_upload_box">
                                    <IconButton component="label">
                                        <AddIcon
                                            color="primary"
                                            fontSize="large"
                                        />
                                        <input
                                            type="file"
                                            accept=".xlsx,.xls"
                                            hidden
                                            onChange={(e) =>
                                                setFile(
                                                    e.target.files?.[0] || null
                                                )
                                            }
                                        />
                                    </IconButton>
                                </Box>
                            )}
                        </Grid>
                    </Grid>

                    {/* 3. Seleccione la hoja a subir */}
                    <Grid className="section_container">
                        <Grid>
                            <Typography className="section_title">
                                3.- Seleccione la hoja a subir
                            </Typography>
                            <Typography className="section_description">
                                Selecciona una de las hojas del archivo
                                seleccionado
                            </Typography>
                        </Grid>
                        <Grid className="custom_select_container">
                            <FormControl
                                size="small"
                                className="custom_select_sheet"
                            >
                                <InputLabel>Hoja</InputLabel>
                                <Select
                                    value={sheet}
                                    label="Hoja"
                                    onChange={(e) => setSheet(e.target.value)}
                                >
                                    {excelSheets.map((sheetName, index) => (
                                        <MenuItem key={index} value={sheetName}>
                                            {sheetName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl
                                size="small"
                                className="custom_select"
                                style={{ minWidth: 120, marginLeft: 16 }}
                            >
                                <input
                                    id="start-row-input"
                                    type="number"
                                    min={1}
                                    value={startRow?.toString() || ""}
                                    onChange={(e) => {
                                        const value = parseInt(
                                            e.target.value,
                                            10
                                        );
                                        setStartRow(isNaN(value) ? 0 : value);
                                    }}
                                    style={{
                                        padding: "10px",
                                        borderRadius: 4,
                                        border: "1px solid #ccc",
                                        width: 200,
                                        fontSize: 16,
                                    }}
                                    placeholder="Fila inicial"
                                />
                                <Typography className="input_label">
                                    Fila inicial
                                </Typography>
                            </FormControl>
                        </Grid>
                    </Grid>

                    {/* 4. Validar Errores y cambios */}
                    <Grid className="section_container">
                        <Grid>
                            <Typography className="section_title">
                                4.- Valida Errores y cambios
                            </Typography>
                        </Grid>
                        <Grid className="left_section">
                            {/* Botón Testear Archivo */}
                            <Grid className="button_container">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className="custom_button"
                                    onClick={() => handleTestFile()}
                                    disabled={!file || !sheet || !projectId}
                                >
                                    Validar Archivo
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>

                    {/* TABS */}
                    <Grid className="tabs_state">
                        {filterStates.map((t, i) => (
                            <Grid
                                className={`tab ${
                                    t.id === activeState && "active"
                                }`}
                                key={i}
                                onClick={() => setActiveState(t.id)}
                            >
                                <Grid>{t.name}</Grid>
                                {t.amountElement ? (
                                    <Grid
                                        className={`numberItems ${
                                            t.id === activeState && "active"
                                        }`}
                                    >
                                        {t.amountElement}
                                    </Grid>
                                ) : null}
                            </Grid>
                        ))}
                    </Grid>

                    {/* button group / ungrouped */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            ml: 6,
                            mt: 1,
                            gap: 2,
                        }}
                    >
                        {internalTabs.map((item, index) => {
                            return (
                                <IconButton
                                    onClick={() =>
                                        onClickChangeSummaryView(item.value)
                                    }
                                    key={index}
                                    className="active_button"
                                    sx={{
                                        backgroundColor:
                                            activeSummaryView === item.value
                                                ? "#1976d2"
                                                : "#f0f0f0",
                                        color:
                                            activeSummaryView === item.value
                                                ? "#fff"
                                                : "#000",
                                        "&:hover": {
                                            backgroundColor:
                                                activeSummaryView === item.value
                                                    ? "#42a5f5"
                                                    : "#f0f0f0",
                                        },
                                    }}
                                >
                                    {item.icon}
                                </IconButton>
                            );
                        })}
                    </Box>

                    {/* Contenido de los tabs */}
                    <Box className="table_container">
                        {activeState === "changes" && (
                            <DataGrid
                                rows={testFielResponse?.changes || []}
                                columns={columnsForChanges}
                                initialState={{
                                    pagination: { paginationModel },
                                }}
                                pageSizeOptions={[10, 20, 50, 100]}
                                checkboxSelection={false}
                                sx={{
                                    border: 0,
                                    "& .MuiDataGrid-columnHeader": {
                                        backgroundColor: "#316EBC",
                                        color: "#fff",
                                        fontWeight: "bold",
                                    },
                                    height: {
                                        md: `calc(100vh - 270px)`,
                                        lg: `calc(100vh - 270px)`,
                                    },
                                }}
                            />
                        )}
                        {activeState === "errors" && (
                            <DataGrid
                                rows={testFielResponse?.errors || []}
                                columns={columnsForChanges}
                                initialState={{
                                    pagination: { paginationModel },
                                }}
                                pageSizeOptions={[10, 20, 50, 100]}
                                checkboxSelection={false}
                                sx={{
                                    border: 0,
                                    "& .MuiDataGrid-columnHeader": {
                                        backgroundColor: "#316EBC",
                                        color: "#fff",
                                        fontWeight: "bold",
                                    },
                                    height: {
                                        md: `calc(100vh - 270px)`,
                                        lg: `calc(100vh - 270px)`,
                                    },
                                }}
                            />
                        )}
                    </Box>

                    {/* 5. Subir los cambios */}
                    <Grid className="section_container">
                        <Grid>
                            <Typography className="section_title">
                                5.- Subir los cambios
                            </Typography>
                            <Typography className="section_description">
                                Proceso de subida de los cambios
                            </Typography>
                        </Grid>
                        <Grid className="left_section">
                            <Box className="button_container">
                                <Button
                                    onClick={() => handleCommitChanges()}
                                    variant="contained"
                                    color="primary"
                                    className="custom_button"
                                    disabled={
                                        rawFielResponse?.changes?.length === 0
                                    }
                                >
                                    Subir Archivos
                                </Button>
                                {rawFielResponse?.changes?.length === 0 && (
                                    <Typography className="disabled_message">
                                        Debes completar los pasos anteriores
                                        para habilitar esta opción.
                                    </Typography>
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
        </>
    );
}
